import styled from 'styled-components';

export const ContainerUpload = styled.div`
  margin: 5px;
`;
